module.exports = {"id":"102056","name":"Simone Padoin","rating":"72","photo":"./data/images/photos/4/102056.png","club":{"name":"Cagliari","logo":"./data/images/clubs/Cagliari.png"},"positions":["DD","MG","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SimonePadoin0.json
// module id = 3970
// module chunks = 0